import { z } from 'zod';
/**
 * To the fighter alone, on every blow they deal or take: how long, from
 * now, they stay in combat (`TELEPORT_COMBAT_LOCK_MS`). No journey and no
 * mounting meanwhile; the client frames the screen in red and greys out
 * what the server would refuse. `ms` = 0 when it ends early (a respawn).
 */
export const CombatLockEventSchema = z.object({ ms: z.number().int().nonnegative() }).strict();
//# sourceMappingURL=combat.js.map